import { render, staticRenderFns } from "./rfa-import-section.vue?vue&type=template&id=32fc6676&"
import script from "./rfa-import-section.vue?vue&type=script&lang=js&"
export * from "./rfa-import-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports